import { getActiveThemeConfig } from 'theme/themes'

export const PLINKO_BOX_COLORS = {
  classic: [0xFF6A00, 0xFF7E00, 0xFF9200, 0xFFAA00, 0xFFBE00, 0xFFBE00, 0xFFAA00, 0xFF9200, 0xFF7E00, 0xFF6A00],
  compact: [0xE53B19, 0xF25E0C, 0xFF8000, 0xFFB500, 0xFFEA00, 0xFFEA00, 0xFFB500, 0xFF8000, 0xF25E0C, 0xE53B19]
}

export const PLINKO_POINT_TINTS = {
  classic: { point: 0xFF9200, shine: 0xFFF0B0 },
  compact: { point: 0xFFFFFF, shine: 0xFFEA00 }
}

export const PLINKO_BALL_TINTS = {
  classic: 0xFF9200,
  compact: 0xEEF1FF
}

export const PLINKO_BALL_ASSETS = {
  classic: 'ball',           // ← Ball1.png (already loaded)
  compact: 'ball__two'  // ← Ball2.png (new)
}

export const getPlinkoBallAsset = (themeConfig = getActiveThemeConfig()) => {
  const layout = getPlinkoLayout(themeConfig)
  return PLINKO_BALL_ASSETS[layout] || PLINKO_BALL_ASSETS.classic
}

export const getPlinkoLayout = (themeConfig = getActiveThemeConfig()) => {
  return themeConfig?.ui?.plinko?.layout || 'classic'
}

export const getPlinkoBoxColors = (themeConfig = getActiveThemeConfig()) => {
  const layout = getPlinkoLayout(themeConfig)
  return PLINKO_BOX_COLORS[layout] || PLINKO_BOX_COLORS.classic
}

export const getPlinkoPointTints = (themeConfig = getActiveThemeConfig()) => {
  const layout = getPlinkoLayout(themeConfig)
  return PLINKO_POINT_TINTS[layout] || PLINKO_POINT_TINTS.classic
}

export const getPlinkoBallTint = (themeConfig = getActiveThemeConfig()) => {
  const layout = getPlinkoLayout(themeConfig)
  return PLINKO_BALL_TINTS[layout] || PLINKO_BALL_TINTS.classic
}

export const isCompactPlinkoTheme = (themeConfig = getActiveThemeConfig()) => {
  return getPlinkoLayout(themeConfig) === 'compact'
}
